module.exports = __webpack_public_path__ + "e32605b0707dcc4f5364fc512b6d7d88.fbx";